<div class="ms-0 rewards-button-background">
  <div *ngSubscribe="purchaseLimit$ as purchaseLimit" class="rewards-button-container ps-0 p-0">
    <div
      class="mb-0 justify-content-center align-items-center"
      *ngSubscribe="limitMessage$ as limitMessage"
      [ngClass]="{ 'mx-3': marketplaceItem.Status == marketplaceItemStatus.Available }"
    >
      <ng-container *ngIf="marketplaceItem.Status == marketplaceItemStatus.Available">
        <fgbcl-number-input
          [isActive]="purchaseLimit | inputActive: marketplaceItem"
          [minValue]="purchaseLimit > 0 ? 1 : 0"
          [maxValue]="purchaseLimit"
          [incrementValue]="1"
          [minMessage]="'1 minimum'"
          [maxMessage]="limitMessage | translate"
          [(amount)]="purchaseQuantity"
          [limitValueToRange]="!marketplaceItem.UnlimitedStock"
          (amountChange)="updatePurchaseValidation(marketplaceItem)"
          [showErrorMessage]="false"
          (errorChange)="onErrorChange($event)"
          [theme]="marketplaceItem.theme"
        >
        </fgbcl-number-input>
      </ng-container>
    </div>

    <div *ngSubscribe="disableCart$ as disableCart" class="button-container-2">
      <div class="">
        <button
          id="purchase-now-button"
          [disabled]="disableCart"
          class="btn btn-block fw-bold text-nowrap px-4 mt-lg-0"
          [ngClass]="{
            'btn-marketplace-unredeemable unredeemable': isUnredeemble,
            'btn-rewards-redeem': !isUnredeemble,
          }"
          (click)="openPurchaseConfirmationModal(disableCart, 'confirmContent')"
        >
          {{ statusText | translate }}
        </button>
      </div>

      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.cart.show'">
        <div class="text-end">
          <button
            id="desktop-addtocart-button"
            class="btn btn-marketplace-cart border-0 mt-4 px-2 ms-2 mt-lg-0 d-none d-lg-block"
            [disabled]="disableCart"
            (click)="addProductToCart(disableCart, true)"
            attr.aria-label="{{ 'cart.add.item.screenreader' | translate }}"
          >
            <img src="assets/images/icons/add_shopping_cart.svg" class="basket-icon" alt="" />
          </button>
          <button
            id="mobile-addtocart-button"
            class="btn btn-marketplace-cart border-0 px-2 ms-2 mt-lg-0 d-lg-none"
            (click)="addProductToCart(disableCart, true)"
            [disabled]="disableCart"
            attr.aria-label="{{ 'cart.add.item.screenreader' | translate }}"
          >
            <img src="assets/images/icons/add_shopping_cart.svg" class="basket-icon" alt="" />
          </button>
        </div>
      </ng-container>
    </div>

    <div *ngIf="hasECash">
      <button
        id="ecash-button"
        [disabled]="purchaseLimit | ecashDisabled: marketplaceItem"
        class="btn btn-warning btn-block fw-bold"
        (click)="openPurchaseConfirmationModal(isEcashButtonDisabled(purchaseLimit), 'confirmContentCardPayment')"
      >
        {{ 'marketplace.buy.with.card' | translate }}
      </button>
    </div>
  </div>
</div>
<!-- Server Side Errors -->
<fgbcl-errors></fgbcl-errors>
